import { useEditor } from '@smartfire/js-block-engine'
import { ReadingTime } from '..'
import style from './style.module.scss'
import clsx from 'clsx'

export const Tile = ({ article, isPages = false }) => {
    const { isEditing } = useEditor()
    return (
        <a href={!isEditing && article.link} className={style.block}>
            <img src={article.thumbnail} alt={article.title} className={style.image} />
            <div className={style.gradient} />
            <div className={clsx(style.container, isPages && style.short)}>
                <h4>{article.title}</h4>
                {article.reading_time && (
                    <ReadingTime min={article.reading_time} classNames={style.readingTime} />
                )}
            </div>
        </a>
    )
}
